import React from 'react';
import { Button } from 'reactstrap';
import { StyledButton } from '../styles';

const FootprintInputButton = ({ text = 'Submit', onClick = () => {} }) => {
  return (
    <StyledButton
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {text}
    </StyledButton>
  );
};

export default FootprintInputButton;
